module.exports = __webpack_public_path__ + "static/monkey_1024-8da2bd5b371b41d8390e914e035e272b.mp4";